// Monthly Staff Overview (views/controlling/StaffHours*.vue). Backend warning details stay English.
export default {
  en: {
    staffHours: {
      month: 'Month',
      payrollOnly: 'Payroll list only',
      export: 'Export for payroll office',
      forbidden: 'Visible to Admin and Bookkeeper roles only.',
      loadFailed: 'Overview could not be loaded.',
      exportFailed: 'Export failed.',
      summary: {
        employees: 'Employees',
        worked: 'Hours worked',
        paidAbsence: 'Paid absence',
        cost: 'Cost',
      },
      cols: {
        personnelNumber: 'Pers. no.',
        name: 'Name',
        team: 'Team',
        timemoto: 'TimeMoto h',
        hubstaff: 'Hubstaff h',
        worked: 'Worked h',
        paidAbsence: 'Paid absence h',
        corrected: 'Corrected h',
        overtimeOld: 'Overtime old',
        overtimeNew: 'Overtime new',
        vacation: 'Vacation',
        holidays: 'Holidays',
        sick: 'Sick',
        cost: 'Cost €',
      },
      freelancer: 'Freelancer',
      noPersonnelNumber: 'No pers. no.',
      manualPart: 'of which manual',
      calendarNrw: 'NRW calendar',
      fixedSalary: 'Fixed salary',
      employerFactor: 'Employer factor',
      note: 'Absences from IQ (without TimeMoto) and NRW public holidays from the calendar count as dates only, without hours/cost. With a monthly target, corrected hours = target and worked + vacation/holiday hours minus target go to the overtime account (sick not credited).',
      warnings: {
        title: 'Notices',
        resetFilter: 'Reset filter',
        openClockingHint: 'Correct in TimeMoto - it is picked up overnight.',
        open_clocking: 'Open clocking',
        unlinked_hubstaff: 'Hubstaff user not linked',
        work_on_absence: 'Work time on absence day',
        unknown_absence_type: 'Unknown absence type',
      },
    },
  },
  de: {
    staffHours: {
      month: 'Monat',
      payrollOnly: 'Nur Lohnliste',
      export: 'Export für Lohnbüro',
      forbidden: 'Nur für Admin- und Bookkeeper-Rolle sichtbar.',
      loadFailed: 'Übersicht konnte nicht geladen werden.',
      exportFailed: 'Export fehlgeschlagen.',
      summary: {
        employees: 'Mitarbeiter',
        worked: 'Arbeitsstunden',
        paidAbsence: 'Bezahlte Abwesenheit',
        cost: 'Kosten',
      },
      cols: {
        personnelNumber: 'Pers.-Nr.',
        name: 'Name',
        team: 'Team',
        timemoto: 'TimeMoto h',
        hubstaff: 'Hubstaff h',
        worked: 'Gearbeitet h',
        paidAbsence: 'Bezahlte Abwesenheit h',
        corrected: 'Stunden korrigiert',
        overtimeOld: 'Überstunden alt',
        overtimeNew: 'Überstunden neu',
        vacation: 'Urlaub',
        holidays: 'Feiertage',
        sick: 'Krank',
        cost: 'Kosten €',
      },
      freelancer: 'Freelancer',
      noPersonnelNumber: 'ohne Pers.-Nr.',
      manualPart: 'davon manuell',
      calendarNrw: 'Kalender NRW',
      fixedSalary: 'Festgehalt',
      employerFactor: 'AG-Faktor',
      note: 'Abwesenheiten aus IQ (ohne TimeMoto) und NRW-Feiertage aus dem Kalender zählen nur als Datum, ohne Stunden/Kosten. Mit Soll-Stunden: korrigiert = Soll, gearbeitet + Urlaub/Feiertag minus Soll geht aufs Überstundenkonto (Krank wird nicht angerechnet).',
      warnings: {
        title: 'Hinweise',
        resetFilter: 'Filter zurücksetzen',
        openClockingHint: 'In TimeMoto korrigieren – wird nachts übernommen.',
        open_clocking: 'Offene Stempelung',
        unlinked_hubstaff: 'Hubstaff-Nutzer nicht verknüpft',
        work_on_absence: 'Arbeitszeit an Abwesenheitstag',
        unknown_absence_type: 'Unbekannte Abwesenheitsart',
      },
    },
  },
}
